import { BaseClient } from '../client';

export type AdminLojistaLista = {
	id: number;
	dat_cadastro: string | null;
	nome: string;
	documento: string;
	status: string;
};

export type AdminLojistaTotais = {
	qtd_ativo: number;
	qtd_inativo: number;
	qtd_pendente: number;
};

interface ApiResponse<T> {
	success: boolean;
	message: string;
	data: T;
}

export const getAdminLojistasList = async (search?: string, status?: string) => {
	const params: Record<string, string> = {};
	if (search?.trim()) params.search = search.trim();
	if (status?.trim()) params.status = status.trim();

	const response = await BaseClient.get<ApiResponse<AdminLojistaLista[]>>('/Admin/Lojista/Get/Lojistas', {
		params,
	});

	return response.data.data ?? [];
};

export const getAdminLojistasTotals = async () => {
	const response = await BaseClient.get<ApiResponse<AdminLojistaTotais>>('/Admin/Lojista/Get/Lojistas/Totais');

	return response.data.data;
};
